import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import circularProgress from "../../public/assets/lottie/circularProgress.json";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { BaseStepProps } from ".";
import { forwardRef, useContext, useImperativeHandle, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useFormContext } from "react-hook-form";
import AstronautLottie from "../../components/AstronautLottie";
import Image from "next/image";
// import { ALREADY_EXIST_PHONE_LOGIN_CODE } from "../../helpers";
import phone from "../../public/assets/onboarding/phone.svg";
import { useBoardingFlow } from "../../hooks/useBoardingFlow";
import { BoardingFlowContext } from "../../context/auth/BoardingFlowContext";

function MyPhoneNumberIsStep(props: BaseStepProps, ref: any) {
  const [isPending, setIsPending] = useState(false);
  const [accountExists, setAccountExists] = useState(false);
  const [, setActiveTab] = useContext(BoardingFlowContext).activeTab;
  const { setValue, watch, clearErrors, setError, formState } =
    useFormContext();
  const { signInWithPhone } = useBoardingFlow();

  useImperativeHandle(ref, () => ({
    reset: () => {
      //   setPhoneNumber("+91");
      //   setPhoneNumberError("");
    },
  }));

  const phoneNumberValue = watch("phoneNumber");

  const handleOpenRoute = (path) => () => {
    const win = window.open(path, "_blank");
    win.focus();
  };

  const handleSignInWithPhone = async () => {
    if (isPending) return;
    setIsPending(true);
    setAccountExists(false);

    // try {
    //   await require("../../firebase-config").auth.signOut();
    //   await require("../../firebase-config").messaging.deleteToken();
    // } catch (e) {}

    // setPhoneRoute(true);
    clearErrors();
    signInWithPhone({
      phoneNumber: phoneNumberValue,
      setIsPending,
      handleSuccess: () => {
        console.log("Setting Active Tab - ", 1);
        // setPhoneRoute(true);
        setIsPending(false);
        setActiveTab(2);
      },
      handleError: (errorMessage) => {
        setIsPending(false);
        setError(
          "phoneNumber",
          {
            message:
              errorMessage ?? "Something went wrong. Please try again later.",
          },
          { shouldFocus: true }
        );
      },
    });
  };

  return (
    <div className="slide__page">
      <div className="third__page__inner">
        <div className="stars__background">
          <div className="stars" />
          <div className="twinkling" />
        </div>
        <div className="top__area">
          <div>
            <button
              className="w-[42px] h-[42px] flex items-center justify-center"
              onClick={() => {
                props.reset();
              }}
            >
              <ArrowBackIosIcon />
            </button>
            <h6>My phone number is</h6>
          </div>

          {isPending ? (
            <button className="sending__otp">
              <Lottie
                options={{
                  animationData: circularProgress,
                  loop: true,
                }}
              />
            </button>
          ) : (
            <button onClick={handleSignInWithPhone}>
              <ArrowForwardIcon style={{ marginTop: "-2px" }} />
            </button>
          )}
        </div>
        <div className="phone__input">
          {props.isOpen && (
            <div>
              <div id="recaptcha-container-2" className="recaptcha" />
            </div>
          )}

          <div>
            <PhoneInput
              country="in"
              value={phoneNumberValue}
              isValid={(_, country) => {
                // setCountryCode(country.dialCode);
                // @ts-ignore
                setValue("countryCode", country.dialCode);
                return true;
              }}
              onChange={(phone) => {
                // setPhoneNumber("+" + phone);
                // setPhoneNumberError("");
                setValue("phoneNumber", "+" + phone);
                clearErrors();
              }}
              placeholder="Enter your phone number here"
              preferredCountries={["us", "ae", "sg", "my", "in"]}
              inputProps={{ autoFocus: true }}
              onEnterKeyPress={handleSignInWithPhone}
            />
            {accountExists && (
              <h6
                style={{
                  color: "gold",
                  fontSize: "15px",
                  margin: "20px 0 0px",
                  paddingTop: 0,
                }}
              >
                Account already exists. Let's sign you in.
              </h6>
            )}
            <h6>We will send a text with verification code.</h6>
            <h6>Message or data rates may apply.</h6>
          </div>
        </div>
        <div className="astronaut__lottie">
          <AstronautLottie />
        </div>
        <Image
          style={{ transform: "scale(-1, 1)" }}
          height={100}
          width={100}
          src={phone}
          alt="phone"
          className="phone__social"
        />

        {formState.errors.phoneNumber && (
          <div className="error__message fadeIn">
            <p>{formState.errors.phoneNumber?.message as string}</p>
            {/* {formState.errors.phoneNumber === ALREADY_EXIST_PHONE_LOGIN_CODE ? (
              <p>
                Account already exist with the phone number. Want to{" "}
                <span
                  style={{ cursor: "pointer", color: "dodgerblue" }}
                  onClick={handleLoginAfterPhoneExist}
                >
                  Login
                </span>
                ?
              </p>
            ) : (
              formState.errors.phoneNumber
            )} */}
          </div>
        )}

        <div className="agreements">
          <h6>By continuing, you agree to our</h6>
          <div>
            <h5 onClick={handleOpenRoute("/terms_of_service")}>
              Terms of Service
            </h5>{" "}
            <h5 onClick={handleOpenRoute("/privacy_policy")}>Privacy Policy</h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default forwardRef(MyPhoneNumberIsStep);
